<mat-card>
  <mat-card-header>
    <mat-card-title>Investment Details</mat-card-title>
  </mat-card-header>

  <mat-card-content class="m-t-1">
    
        <app-radio-input 
                label="During the previous 4 years, have you had an ownership interest and management involvement in any business?" 
                [control]="investmentForm.controls.hadOwnership"  shortLabel="Had Ownership"
                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
                [submitAttempted]="submitAttempted">
          </app-radio-input>


      @if (model.investment!.hadOwnership === 'true') {
        <div class="section-label">
          <mat-label>Please provide details of your businesses</mat-label>
        </div>

        @if (model.investment!.ownerships.length > 0) {
          @if(!(isMobile$ | async)) {
          <table mat-table [dataSource]="ownershipDataSource" class="mat-elevation-z1">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>

            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef>Country</th>
              <td mat-cell *matCellDef="let element">{{element.country?.Value}}</td>
            </ng-container>
            
            <ng-container matColumnDef="industry">
              <th mat-header-cell *matHeaderCellDef>Industry</th>
              <td mat-cell *matCellDef="let element">{{element.industry?.value}}</td>
            </ng-container>

            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>Position</th>
              <td mat-cell *matCellDef="let element">{{element.position}}</td>
            </ng-container>
  

            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef>Edit</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button (click)="edit(i)">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef>Delete</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button color="warn" (click)="remove(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          }
          @if(isMobile$ | async) {
             <div class="mobile-cards">
        @for(ownership of model.investment!.ownerships; track ownership; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Name:</span>
                <span class="value">{{ownership.name}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Country:</span>
                <span class="value">{{ownership.country?.Value}}</span>
              </div>
              
              <div class="mobile-card-item">
                <span class="label">Industry:</span>
                <span class="value">{{ownership.industry?.value}}</span>
              </div>
            
            
              <div class="mobile-card-item">
                <span class="label">Position:</span>
                <span class="value">{{ownership.position}}</span>
              </div>
            
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="edit(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="remove(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>
          }
        }

        <button mat-raised-button color="primary" (click)="add()">Add business</button>
      }
  </mat-card-content>
</mat-card>